// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-content[data-v-6f575df1]{position:relative;transition:height .5s cubic-bezier(.38,.2,.36,1.04)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
